import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { claytonConfig } from "./data";

export default function ClaytonPage() {
  return <CityPageTemplate config={claytonConfig} />;
}